import { FormattedMessage } from 'react-intl'
import { Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'

export const DefaultNotFoundPage = () => {
  const isMdAndSmaller = useMediaQuery('down', 'md')
  const { isAuthorized } = useAuth()

  return (
    <div className="flex h-dvh flex-col items-center justify-center gap-6 bg-gradient-primary-vertical">
      <Typography
        className="text-[80px] md:text-[120px]"
        color="primary"
        variant="h1"
      >
        404
      </Typography>
      <div className="flex flex-col gap-2">
        <Typography
          color="text.primary"
          variant={isMdAndSmaller ? 'h6' : 'h5'}
        >
          <FormattedMessage id="notFound.title" />
        </Typography>
        <Typography
          color="text.secondary"
          variant={isMdAndSmaller ? 'body3' : 'body2'}
        >
          <FormattedMessage id="notFound.description" />
        </Typography>
      </div>

      <Button
        as={Link}
        color="primary"
        to={isAuthorized ? '/dashboard' : '/login'}
        variant="contained"
      >
        <FormattedMessage id="common.controls.backToHome" />
      </Button>
    </div>
  )
}
